

interface Props {
    formulario: any;
}

export const Forma8Pdf = ({ formulario }: Props) => {
    return (
        <>
            <div className="row ">
                <div className="col-12 color-celda celda">
                    <h5>VERIFICACIÓN DE LA INFORMACIÓN CONSIGNADA</h5>
                </div>
            </div>

            <div className="row">
                <div className="col-6 color-celda">
                    <label className='titul-form'>Nombre Completo del funcionario:</label>
                    <p>{formulario.nombrefuncioinfo}</p>
                </div>
                <div className="col-6 color-celda">
                    <label className='titul-form'>No. Cedula de Ciudadania del funcionario:</label>
                    <p>{formulario.ciudadfuncionarioinfo}</p>
                </div>

            </div>

            <div className="row">
                <div className="col-12 color-celda">
                    <label className='titul-form'>Fecha de consulta - dd/mm/año</label>
                    <p>{formulario.fechacreacioninfo}</p>
                </div>
            </div>
            {/* <PrintJson  json={formulario}/> */}
        </>
    )
} 